/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { SearchFacet } from './SearchFacet';
import {
    SearchFacetFromJSON,
    SearchFacetFromJSONTyped,
    SearchFacetToJSON,
    SearchFacetToJSONTyped,
} from './SearchFacet';
import type { SolrPublisher } from './SolrPublisher';
import {
    SolrPublisherFromJSON,
    SolrPublisherFromJSONTyped,
    SolrPublisherToJSON,
    SolrPublisherToJSONTyped,
} from './SolrPublisher';

/**
 * 
 * @export
 * @interface SolrResultSolrPublisher
 */
export interface SolrResultSolrPublisher  {
    /**
     * 
     * @type {number}
     * @memberof SolrResultSolrPublisher
     */
    numberResults?: number;
    /**
     * 
     * @type {Array<SolrPublisher>}
     * @memberof SolrResultSolrPublisher
     */
    results?: Array<SolrPublisher>;
    /**
     * 
     * @type {Array<SearchFacet>}
     * @memberof SolrResultSolrPublisher
     */
    facets?: Array<SearchFacet>;
}

/**
 * Check if a given object implements the SolrResultSolrPublisher interface.
 */
export function instanceOfSolrResultSolrPublisher(value: object): value is SolrResultSolrPublisher {
    return true;
}

export function SolrResultSolrPublisherFromJSON(json: any): SolrResultSolrPublisher {
    return SolrResultSolrPublisherFromJSONTyped(json, false);
}

export function SolrResultSolrPublisherFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrResultSolrPublisher {
    if (json == null) {
        return json;
    }
    return {
        
                  'numberResults': json['numberResults'] == null ? undefined : json['numberResults'],
              'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SolrPublisherFromJSON)),
              'facets': json['facets'] == null ? undefined : ((json['facets'] as Array<any>).map(SearchFacetFromJSON)),
    };
}

export function SolrResultSolrPublisherToJSON(json: any): SolrResultSolrPublisher {
    return SolrResultSolrPublisherToJSONTyped(json, false);
}

export function SolrResultSolrPublisherToJSONTyped(value?: SolrResultSolrPublisher | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'numberResults': value['numberResults'],
        'results': value['results'] == null? value['results']: (value['results'] as Array<any>).map(SolrPublisherToJSON),
        'facets': value['facets'] == null? value['facets']: (value['facets'] as Array<any>).map(SearchFacetToJSON),
    };
}


